import { render, staticRenderFns } from "./ModalFavoritesInfo.vue?vue&type=template&id=4ed632e7&"
import script from "./ModalFavoritesInfo.vue?vue&type=script&lang=js&"
export * from "./ModalFavoritesInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalFavoritesInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports